"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
/**
 * NsCard component
 *
 * This component is a wrapper for the custom HTML element <ns-card>.
 * It accepts various props to customize its appearance and behavior.
 * The type="section" card has been deprecated. The type will switch to standard when section is applied.
 *
 * @param {Object} props - The properties object.
 * @param {'standard' | 'section' | 'support' | 'flat' | 'nav' | 'highlighter'} props.type - The type of card to be displayed.
 * @param {React.ReactNode} props.children - The content to be displayed inside the card.
 * @param {string} [props.decoration] - Optional decoration for the card.
 * @param {string} [props.image] - Optional image URL for the card.
 * @param {string} [props.alt] - Optional alt text for the image.
 * @param {boolean} [props.pillOverImage] - Optional flag to indicate if a pill should be displayed over the image.
 * @param {boolean} [props.inactive] - Optional flag to indicate if the card is inactive.
 * @param {string} [props.inactiveMessage] - Optional message to be displayed when the card is inactive.
 * @param {Object} rest - Additional properties to be passed to the <ns-card> element.
 *
 * @returns {JSX.Element} The rendered <ns-card> element.
 */
var NsCard = function (_a) {
    var type = _a.type, children = _a.children, decoration = _a.decoration, image = _a.image, alt = _a.alt, pillOverImage = _a.pillOverImage, inactive = _a.inactive, inactiveMessage = _a.inactiveMessage, rest = __rest(_a, ["type", "children", "decoration", "image", "alt", "pillOverImage", "inactive", "inactiveMessage"]);
    return (React.createElement("ns-card", __assign({ type: type, decoration: decoration, image: image, alt: alt, "pill-over-image": pillOverImage, inactive: inactive, "inactive-message": inactiveMessage }, rest), children));
};
exports.default = NsCard;
